import { Field, FieldProps } from "formik";
import { SCheckbox, SSearchFilterGroupOptionLabel } from "../../../styles/StyledSearchFilters";
import { DatePicker } from "../../DatePicker";
import { useTranslation } from "react-i18next";
import moment from "moment";

type SearchFiltersFieldProps = CheckboxFieldType | DatePickerFieldType;

type CheckboxFieldType = {
	type: "checkbox";
	group: {
		name: string;
	};
	option: {
		name: string;
		id: number | string;
	};
};

type DatePickerFieldType = {
	type: "date";
	name: string;
};

export const SearchFiltersField = (props: SearchFiltersFieldProps) => {
	const { t } = useTranslation();

	const { type } = props;
	switch (type) {
		case "checkbox": {
			const { group, option } = props;
			return (
				<SSearchFilterGroupOptionLabel>
					<Field type="checkbox" name={group.name} value={`${option.id}`}>
						{({ field }: FieldProps) => {
							return (
								<SCheckbox id={`${option.name}${option.id}`}>
									<span className={field.checked ? "checked" : ""}></span>
									<input type="checkbox" {...field} />
								</SCheckbox>
							);
						}}
					</Field>
					{t(`${option.name}`)}
				</SSearchFilterGroupOptionLabel>
			);
		}
		case "date": {
			const { name } = props;
			return (
				<Field type="text" name={name}>
					{({ field, form }: FieldProps) => {
						const setValue = (value: string | undefined) => {
							form.setFieldValue(field.name, value);
							form.submitForm();
						};

						const handleChange = (value: Date | undefined) => {
							switch (field.name) {
								case "startDate":
									if (value === undefined) {
										setValue(value);
									}
									if (form.values["endDate"]) {
										if (moment(value).isSameOrBefore(moment(form.values["endDate"], "YYYY-MM-DD"), "day")) {
											setValue(moment(value).format("YYYY-MM-DD"));
										}
									} else {
										setValue(moment(value).format("YYYY-MM-DD"));
									}

									break;
								case "endDate":
									if (value === undefined) {
										setValue(value);
									}
									if (form.values["startDate"]) {
										if (form.values["startDate"] && moment(value).isSameOrAfter(moment(form.values["startDate"], "YYYY-MM-DD"), "day")) {
											setValue(moment(value).format("YYYY-MM-DD"));
										}
									} else {
										setValue(moment(value).format("YYYY-MM-DD"));
									}

									break;
								default:
									setValue(moment(value).format("YYYY-MM-DD"));
									break;
							}
						};
						return (
							<DatePicker
								id={name}
								data-testid={name}
								autoComplete="off"
								placeholderText={t(`${name}`)}
								{...field}
								handleChange={handleChange}
							/>
						);
					}}
				</Field>
			);
		}
		default:
			return <></>;
	}
};
